const deviceStatus = async (_, { customer_id, device_id }) => {
  const queryString = `customer_id=${customer_id}&device_id=${device_id}`;
  const resp = await window.axios.get(`/proxy/device-manager/?${queryString}`);
  return resp;
};

export default deviceStatus;
